import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

const displayDuration = 3000;

export function FlashMessage({ variant, defaultShow, children, onClose=()=>{} }) {
  const [ show, setShow ] = useState(defaultShow);

  let className;
  switch (variant) {
    case 'success':
      className = 'bg-success text-white border-0';
      break;
    case 'danger':
      className = 'bg-danger text-white border-0';
      break;

    default:
      className = 'bg-info text-white border-0';
  }

  setTimeout(() => {
    handleClose();
  }, displayDuration);

  const handleClose = ()=>{
    setShow(false);
    onClose();
  };

  return (
    <Alert variant={variant} onClose={handleClose} show={show} dismissible={true} className={className}>
      {children}
    </Alert>
  );
}
